/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAxiosCall } from '../../services/api';
import { useState } from 'react';
import { ApiConfig } from '../../types/models/api/apiConfig';
import { getHeaders } from './getHeaders';

import { useGetProfileState } from '../../store/profile/selector';

interface Response {
  status: number;
  data: any;
  success: boolean;
}

const useGetData = (): {
  isFetching: boolean;
  getData: (config: ApiConfig) => Promise<any>;
} => {
  const [isFetching, setIsFetching] = useState(false);

  const { accessToken } = useGetProfileState();

  const getData = async ({
    path,
    config,
    headers,
    params,
    apiType,
    useAuth = true,
    controller
  }: ApiConfig): Promise<any> => {
    const API_TYPE = apiType;

    try {
      setIsFetching(true);
      const authHeaders = getHeaders(useAuth, accessToken);

      const AXIOS = getAxiosCall(API_TYPE);

      const response = await AXIOS.get<Response>(path, {
        ...params,
        config,
        headers: {
          ...authHeaders,
          ...headers
        },
        signal: controller?.signal
      });

      return response.data;
    } catch (err) {
      if (controller?.signal.aborted) {
        console.log('The user aborted the request');
      }

      throw err;
    } finally {
      setIsFetching(false);
    }
  };

  return { isFetching, getData };
};

export default useGetData;
